<!--<template>-->
<!--  <scroll-bar>-->
<!--    <el-menu-->
<!--      mode="vertical"-->
<!--      :show-timeout="200"-->
<!--      :default-active="$route.path"-->
<!--      :collapse="isCollapse"-->
<!--      background-color="#304156"-->
<!--      text-color="#bfcbd9"-->
<!--      active-text-color="#409EFF"-->
<!--    >-->
<!--      <sidebar-item :routes="routes"></sidebar-item>-->
<!--    </el-menu>-->
<!--  </scroll-bar>-->
<!--</template>-->

<!--<script>-->
<!--import { mapGetters } from 'vuex'-->
<!--import SidebarItem from './SidebarItem'-->
<!--import ScrollBar from '@/components/ScrollBar'-->

<!--export default {-->
<!--  components: { SidebarItem, ScrollBar },-->
<!--  computed: {-->
<!--    ...mapGetters([-->
<!--      'sidebar',-->
<!--      'routers'-->
<!--    ]),-->
<!--    routes() {-->
<!--      // return this.$router.options.routes-->
<!--      return this.routers-->
<!--    },-->
<!--    isCollapse() {-->
<!--      return !this.sidebar.opened-->
<!--    }-->
<!--  }-->
<!--}-->
<!--</script>-->
<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in routers" :key="route.name" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  // import Logo from './Logo'
  import SidebarItem from './SidebarItem'
  import variables from '@/styles/variables.scss'
  export default {
    components: { SidebarItem },
    computed: {
      ...mapGetters([
        'routers',
        'sidebar'
      ]),
      activeMenu() {
        const route = this.$route
        const { meta, path } = route
        // if set path, the sidebar will highlight the path you set
        if (meta.activeMenu) {
          return meta.activeMenu
        }
        return path
      },
      showLogo() {
        // return this.$store.state.settings.sidebarLogo
        return false
      },
      variables() {
        return variables
      },
      isCollapse() {
        return !this.sidebar.opened
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue